import { IconeConversa, IconeDocumento } from '../components/IconesDeDocumento'
import { TEXTOS } from './glossario'
import type { GrupoDeNavegacao } from './navegacao'

/**
 * Grupo "O contrato": o texto que manda — o TR, o contrato, os aditivos — e a consulta a ele.
 *
 * Grupo próprio, e não mais um item de "Acompanhamento" ou de "Fechamento": aqueles respondem "o que
 * aconteceu no mês" e "quanto vale". Este responde "o que o contrato diz", que é a pergunta de antes
 * e de depois de todas as outras. A consulta vem primeiro porque é ela que a pessoa procura; os
 * documentos são a base que a fiscalização mantém.
 *
 * Do lado CONTRATANTE, como no servidor (`@PreAuthorize(CONTRATANTE)`).
 */
export const DOCUMENTOS_DO_CONTRATO: GrupoDeNavegacao = {
  id: 'contrato-documentos',
  rotulo: 'O contrato',
  itens: [
    {
      id: 'consulta',
      rotulo: TEXTOS.consulta.titulo,
      para: '/consulta',
      icone: IconeConversa,
      organizacao: 'CONTRATANTE',
      situacao: 'pronto',
      resumo: TEXTOS.consulta.descricao,
    },
    {
      id: 'documentos',
      rotulo: TEXTOS.documentos.titulo,
      para: '/documentos',
      icone: IconeDocumento,
      organizacao: 'CONTRATANTE',
      situacao: 'pronto',
      resumo: TEXTOS.documentos.descricao,
    },
  ],
}
